module.exports = __webpack_public_path__ + "img/11_34.e8f0fcb8.png";